(function(){
  if(window.__mmCardsInit)return;window.__mmCardsInit=true;
  var CHECK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
  var toastT;
  function toast(m){
    var t=document.querySelector('.mm-card-toast');
    if(!t){t=document.createElement('div');t.className='mm-card-toast';document.body.appendChild(t);}
    t.innerHTML=m;t.classList.add('show');clearTimeout(toastT);
    toastT=setTimeout(function(){t.classList.remove('show');},1900);
  }
  // Wishlist King — v3 (260715) DUPLIKAT-FIX, v4/v4b (260715) PDP-HERZ.
  // v3: die appmate-API erlaubt denselben Artikel mehrfach; Mapping handle→ItemId liegt jetzt
  // in localStorage (mm_wk_map), Add nur wenn nicht gemerkt, wkDedupe() räumt Duplikate leise auf.
  // v4: der Klick-Listener matchte nur .mm-card__wish — das PDP-Galerie-Herz (.mm-gal__heart)
  // und die Cross-Sell-Herzen (.mm-xwish) tragen zwar data-wish, waren aber NIE verkabelt
  // (Klick tat nichts!). Jetzt: EIN Listener für alle [data-wish]-Herzen + wkPaint() färbt beim
  // Laden alle Herzen ein, deren Produkt schon gemerkt ist (Map; auf der PDP zusätzlich
  // Server-Abgleich über productId — der backfillt auch das Mapping fürs Abwählen).
  // v4b: Wishlist King lädt auf der PDP erst nach ~3-4s — ein Klick davor lief in den Guard
  // und tat still NICHTS (Herz blieb rot, nichts gespeichert!). Jetzt: bis 5s auf die App
  // warten (Polling 200ms), danach sichtbar zurücksetzen + Fehlertoast.
  var WKMAP='mm_wk_map';
  function wkMap(){try{return JSON.parse(localStorage.getItem(WKMAP))||{}}catch(e){return {}}}
  function wkSave(m){try{localStorage.setItem(WKMAP,JSON.stringify(m))}catch(e){}}
  window.__mmWkIds=window.__mmWkIds||{};
  var wkCss=document.createElement('style');
  wkCss.textContent='.mm-gal__heart.on svg path,.mm-xwish.on svg path{fill:#E4344B !important;stroke:#E4344B !important}';
  (document.head||document.documentElement).appendChild(wkCss);
  function wkHandleFor(el){
    var c=el.closest('[data-product-handle]');
    if(c&&c.getAttribute('data-product-handle'))return c.getAttribute('data-product-handle');
    var m=location.pathname.match(/\/products\/([^\/?]+)/);
    return (el.classList.contains('mm-gal__heart')&&m)?m[1]:'';
  }
  function wkPaint(){
    var map=wkMap();
    document.querySelectorAll('[data-wish]').forEach(function(h){
      var handle=wkHandleFor(h);
      if(!handle)return;
      if(map[handle]&&map[handle].iid)h.classList.add('on');
    });
  }
  var wkDedupeRunning=false;
  function wkDedupe(){
    try{
      if(wkDedupeRunning)return;
      if(!window.WishlistKing||!window.WishlistKing._apis||!window.WishlistKing._apis.wishlist)return;
      wkDedupeRunning=true;
      window.WishlistKing._apis.wishlist.get({path:'/wishlists/mine'}).then(function(r){
        var items=(r&&r.wishlist&&r.wishlist.items)||[];
        var seen={};
        var survivors=[];
        var chain=Promise.resolve();
        items.forEach(function(i){
          var k=String(i.productId)+':'+String(i.variantId);
          if(seen[k]){
            chain=chain.then(function(){
              return window.WishlistKing.removeWishlistItem({wishlistItemId:i.id}).catch(function(){});
            });
          }else{seen[k]=i.id;survivors.push(i);}
        });
        // PDP-Server-Abgleich: ist DIESES Produkt gemerkt? (metaPid ist die zuverlässige Quelle;
        // das versteckte wk-selected im Header heißt nur „Liste nicht leer" — NICHT Produktstatus!)
        var meta=window.ShopifyAnalytics&&window.ShopifyAnalytics.meta&&window.ShopifyAnalytics.meta.product;
        var pm=location.pathname.match(/\/products\/([^\/?]+)/);
        if(meta&&pm){
          var mine=survivors.filter(function(i){return String(i.productId)===String(meta.id);});
          var gal=document.querySelector('.mm-gal__heart[data-wish]');
          var m=wkMap();
          if(mine.length){
            if(gal)gal.classList.add('on');
            if(!m[pm[1]]||!m[pm[1]].iid){m[pm[1]]={iid:mine[0].id};wkSave(m);}
          }else{
            if(gal)gal.classList.remove('on');
            if(m[pm[1]]){delete m[pm[1]];wkSave(m);}
          }
        }
        wkPaint();
        return chain;
      }).then(function(){wkDedupeRunning=false;}).catch(function(){wkDedupeRunning=false;});
    }catch(e){wkDedupeRunning=false;}
  }
  window.__mmWkToggle=function(on,handle,revert){
    if(!handle){if(revert)revert();return;}
    var tries=0;
    (function go(){
    if(!window.WishlistKing){
      if(++tries>25){if(revert)revert();toast('Fehler — bitte nochmal versuchen');return;}
      setTimeout(go,200);return;
    }
    var map=wkMap();
    if(on){
      if(map[handle]&&map[handle].iid){window.__mmWkIds[handle]=map[handle].iid;return;} // schon gemerkt → kein 2. Eintrag
      window.WishlistKing.addWishlistItem({productHandle:handle}).then(function(res){
        var it=res&&res.wishlistItem;
        if(it){
          window.__mmWkIds[handle]=it.id;
          var m=wkMap();m[handle]={iid:it.id};wkSave(m);
        }
        setTimeout(wkDedupe,800); // Sicherheitsnetz (z.B. zweiter Tab / App-eigener Button)
      }).catch(function(){if(revert)revert();toast('Fehler — bitte nochmal versuchen');});
    }else{
      var wid=(map[handle]&&map[handle].iid)||window.__mmWkIds[handle];
      if(wid){
        window.WishlistKing.removeWishlistItem({wishlistItemId:wid}).then(function(){
          delete window.__mmWkIds[handle];
          var m=wkMap();delete m[handle];wkSave(m);
        }).catch(function(){
          // Eintrag existierte serverseitig nicht mehr → Mapping trotzdem aufraeumen
          delete window.__mmWkIds[handle];
          var m=wkMap();delete m[handle];wkSave(m);
        });
      }
    }
    })();
  };
  function wkInit(){wkPaint();setTimeout(wkDedupe,2000);}
  if(document.readyState==='complete'||document.readyState==='interactive'){wkInit();}
  else{document.addEventListener('DOMContentLoaded',wkInit);}
  // Warenkorb (Kachel) – nur Einzelvariante; Mehrfachvarianten sind im Markup ein Link zur PDP.
  // v2 (260713) OPTIMISTISCHES UI: /cart/add.js braucht ~700ms — vorher sah der Kunde solange
  // NICHTS. Jetzt: Haken, Toast und Badge (+1 via window.mmBumpBadge aus maomao-tabbar) SOFORT
  // beim Klick; der Server bestätigt im Hintergrund. Fehlerfall (ausverkauft/Limit — vorher
  // wurde r.ok gar nicht geprüft!): Button/Badge zurücksetzen + Fehlermeldung.
  document.addEventListener('click',function(e){
    var b=e.target.closest('.mm-card__add[data-add]');if(!b)return;
    e.preventDefault();e.stopPropagation();
    var id=parseInt(b.getAttribute('data-add'),10);if(!id){toast('Nicht verfügbar');return;}
    var old=b.innerHTML;
    b.disabled=true;b.innerHTML=CHECK;b.classList.add('added');
    if(window.mmBumpBadge)window.mmBumpBadge(1);
    toast('✓ Erfolgreich in den Warenkorb gelegt');
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
      .then(function(r){return r.json().then(function(body){return {ok:r.ok,body:body};});})
      .then(function(x){
        if(!x.ok){
          b.innerHTML=old;b.classList.remove('added');b.disabled=false;
          toast((x.body&&(x.body.description||x.body.message))||'Fehler beim Hinzufügen');
          document.dispatchEvent(new CustomEvent('cart:change',{bubbles:true}));
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        document.dispatchEvent(new CustomEvent('cart:change',{bubbles:true}));
        setTimeout(function(){b.innerHTML=old;b.classList.remove('added');b.disabled=false;},1400);
      })
      .catch(function(){
        b.innerHTML=old;b.classList.remove('added');b.disabled=false;
        toast('Fehler beim Hinzufügen');
        document.dispatchEvent(new CustomEvent('cart:change',{bubbles:true}));
      });
  });
  // Wunschliste — v4: EIN Listener für ALLE Herzen (Kachel .mm-card__wish, PDP-Galerie
  // .mm-gal__heart, Cross-Sell .mm-xwish) — alle tragen [data-wish]
  document.addEventListener('click',function(e){
    var h=e.target.closest('[data-wish]');if(!h)return;
    e.preventDefault();e.stopPropagation();
    var handle=wkHandleFor(h);
    if(!handle){toast('Fehler — bitte nochmal versuchen');return;}
    var on=h.classList.toggle('on');
    window.__mmWkToggle(on,handle,function(){h.classList.toggle('on');});
    toast(on?'♥ Zur Wunschliste hinzugefügt':'Aus Wunschliste entfernt');
  });
})();
